import {
	REQUEST_AUDIT_STATUS,
	RECEIVE_AUDIT_STATUS,
	AUDIT_STATUS_ERROR,
	REQUEST_AUDIT_STATUS_USER,
	RECEIVE_AUDIT_STATUS_USER,
	AUDIT_STATUS_USER_ERROR,
	REQUEST_AUTHORIZE_AUDIT,
	RECEIVE_AUTHORIZE_AUDIT,
	AUTHORIZE_AUDIT_ERROR,
	REQUEST_UNAUTHORIZE_AUDIT,
	RECEIVE_UNAUTHORIZE_AUDIT,
	UNAUTHORIZE_AUDIT_ERROR,
} from "../actions/auditActions";

import { RECEIVE_LOGOUT_USER } from "../actions/activeUserActions";

import { RECEIVE_ACTIVE_MODEL } from "../actions/activeModelActions";
const initialAuditState = {
	isFetching: false,
	audit: {
		modelId: "",
		audit: [],
		revisionPost: "",
		revisionPrev: "",
	},
	userAudit: {
		p_owner: {},
		responsibilities_with_changes: [],
	},
	error: null,
};

export const auditReducer = (state = initialAuditState, action) => {
	switch (action.type) {
		case REQUEST_AUDIT_STATUS:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_AUDIT_STATUS:
			//sets new state and fetching ended
			if (action.payload.message === "need more than 1 model revision") {
				return { ...state, userAudit: initialAuditState.userAudit, isFetching: false };
			} else {
				return { ...state, audit: action.payload.audit, isFetching: false };
			}
		case AUDIT_STATUS_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_AUDIT_STATUS_USER:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_AUDIT_STATUS_USER:
			//sets new state and fetching ended
			if (action.payload.message === "need more than 1 model revision") {
				return { ...state, userAudit: initialAuditState.userAudit, isFetching: false };
			}
			if (Object.keys(action.payload.audit).length === 0 && action.payload.audit.constructor === Object) {
				return { ...state, userAudit: initialAuditState.userAudit, isFetching: false };
			} else {
				return { ...state, userAudit: action.payload.audit, isFetching: false };
			}
		case RECEIVE_LOGOUT_USER:
			//when user ist logged out, audit status is reset
			return { ...state, userAudit: initialAuditState.userAudit, isFetching: false };
		case AUDIT_STATUS_USER_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_AUTHORIZE_AUDIT:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_AUTHORIZE_AUDIT:
			//sets new state and fetching ended
			const alteredAuditAuthorized = state.audit.audit.map(audit => ({
				...audit,
				responsibilities_with_changes: audit.responsibilities_with_changes.map(process =>
					process._id === action.payload.processId && process.status === "unauthorised"
						? { ...process, status: "authorised" }
						: process
				),
			}));

			const authorizedResponsibilties = state.userAudit.responsibilities_with_changes.map(process =>
				process._id === action.payload.processId && process.status === "unauthorised"
					? { ...process, status: "authorised" }
					: process
			);

			return {
				...state,
				audit: { ...state.audit, audit: alteredAuditAuthorized },
				userAudit: { ...state.userAudit, responsibilities_with_changes: authorizedResponsibilties },
				isFetching: false,
			};
		case AUTHORIZE_AUDIT_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_UNAUTHORIZE_AUDIT:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_UNAUTHORIZE_AUDIT:
			//sets new state and fetching ended
			const alteredAuditUnauthorized = state.audit.audit.map(audit => ({
				...audit,
				responsibilities_with_changes: audit.responsibilities_with_changes.map(process =>
					process._id === action.payload.processId && process.status === "authorised"
						? { ...process, status: "unauthorised" }
						: process
				),
			}));

			const unauthorizedResponsibilties = state.userAudit.responsibilities_with_changes.map(process =>
				process._id === action.payload.processId && process.status === "authorised"
					? { ...process, status: "unauthorised" }
					: process
			);
			return {
				...state,
				audit: { ...state.audit, audit: alteredAuditUnauthorized },
				userAudit: { ...state.userAudit, responsibilities_with_changes: unauthorizedResponsibilties },
				isFetching: false,
			};
		case UNAUTHORIZE_AUDIT_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case RECEIVE_ACTIVE_MODEL:
			return initialAuditState;
		default:
			return state;
	}
};
